import { arrayRemove, arrayUnion, writeBatch } from 'firebase/firestore'
import _ from 'lodash'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Icon, Label, Menu, Message } from 'semantic-ui-react'
import { GoogleSheetsContext } from '../../cnr/contexts/GoogleSheetsContext'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { convertHelpers } from '../../common/convert'
import { uniqueKey } from '../../common/keys'
import UiSaveButtons from '../../components/buttons/UiSaveButtons'
import AlphabetMenuWithProvider from '../../components/menus/AlphabetMenu'
import { gEnums } from '../../enums/globalEnums'
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths'
import { updateLinkHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_dataLInks'
import { updateDocumentHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_document'
import { DataLinkContext } from '../../pageItem/modification/dataModifications/DataLinking'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import WrapperVertCols from '../../wrappers/WrapperVertCols'
import { useDataLinking } from 'global/cnr/contexts/useHelpers/useDataLinking'
import { _cacheGroupTypes } from 'global/cnr/contexts/useHelpers/useTimestamp'
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging'
import { useGoogleSheets } from 'global/cnr/contexts/useHelpers/useGoogleSheets'

const _alphaLimit = 20
const _allowUpdate = true
const _labelSize = 'tiny'

/**
 * dataLinkProps {linkCollection, parentCollection, parentCollectionKey}
 * @param {object} dataLinking  
 * @returns 
 */
const DataLinkingMenus = ({ dataLinking, dlps }) => {

  const dl = useDataLinking({ dlps })
  const _dataLinking = dlps ? dl : dataLinking
  const { viewItem_right: viewItem, dataLinkProps, data_page: currentParentItemData } = _dataLinking ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, eventInfo_state, paps_state, currentSettings_state } = states
  const { mainDb } = app_state ?? {}
  const { database_fns } = fns
  const { pathViews } = paps_state ?? {}
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appDataSource, googleSheets } = aps_global ?? {}
  const { appDataLinkType } = appDataSource ?? {}
  const { googleSheetsId } = googleSheets ?? {}


  const { getGoggleSheetSimple } = useGoogleSheets()

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_handlers } = googleSheetsContext ?? {}

  const [appDataLinks] = useState(_.cloneDeep(eventInfo_state?.appDataLinks))
  const [appDataDocuments] = useState(_.cloneDeep(eventInfo_state?.appDataDocuments))

  // dataModificationsContext
  const dataLinkContext = useContext(DataLinkContext)
  const { dataLink_handlers } = dataLinkContext ?? {}

  const { key: key_view } = viewItem ?? {}

  const [changed, setChanged] = useState()
  const [currentList, setCurrentList] = useState()
  const [currentLists, setCurrentLists] = useState()
  const [updating, setUpdating] = useState()
  const [useAlphas, setUseAlphas] = useState()
  const [showSelected, setShowSelected] = useState(true)
  const [soloLinkOnly, setSoloLinkOnly] = useState()
  const [messages, setMessages] = useState()

  const handleShowSelected = () => setShowSelected(!showSelected)
  const handleSoloLinkOnly = () => setSoloLinkOnly(!showSelected)

  const vi = aps_viewItems[dataLinkProps?.linkCollection]

  const { dataConnection } = vi ?? {}
  const { uniqueProps } = dataConnection ?? {}

  const topRef = useRef();
  const alphaRefs = useRef([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMessages(false);
    }, 3000); // 2 seconds

    return () => clearTimeout(timer);
  }, [messages]);

  // updates when dataLinkProps.linkCollection changes
  useEffect(() => {
    if (currentParentItemData && dataLinkProps?.linkCollection && appDataLinks) {
      resetList()
    } else {
      setCurrentList(null)
      setCurrentLists(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [dataLinkProps?.linkCollection]);

  const resetList = () => {
    // appDataLinks contain no other information asside from the keys  
    // these are similar
    const _appDataLink = eventInfo_state?.appDataLinks ? _.cloneDeep(eventInfo_state?.appDataLinks[dataLinkProps?.linkCollection]) : null
    const _appDataDoc = eventInfo_state?.appDataDocuments ? _.cloneDeep(appDataDocuments?.[dataLinkProps?.linkCollection]) : null

    convertHelpers.createItemKeys(_appDataLink)
    convertHelpers.createItemKeys(_appDataDoc)

    const _cls = convertHelpers.getMerged(_appDataDoc, _appDataLink, dataLinkProps?.parentCollection, ['_selected', '_changed'], dataLinkProps?.parentCollectionKey, uniqueProps)

    const _selectedLinkItems = {}

    _.forEach(_appDataLink, (linkItem, linkKey) => {
      const itemCollectionData = linkItem[key_view]
      let _selected = false;
      if (itemCollectionData && itemCollectionData.includes(dataLinkProps?.parentCollectionKey)) { _selected = true }
      linkItem._selected = _selected
      _selectedLinkItems[linkKey] = {
        _selected: _selected,
        _changed: false
      }
    })

    _.forEach(_appDataDoc, (staticItem) => {
      const { _itemKey } = staticItem
      let _selected;
      if (currentParentItemData && currentParentItemData[dataLinkProps.linkCollection] && currentParentItemData[dataLinkProps.linkCollection].includes(_itemKey)) { _selected = true }
      staticItem._selected = _selected
    })

    _.forEach(_appDataDoc, (appDataDocumentItem) => {
      const { _itemKey } = appDataDocumentItem
      let _selected;
      if (currentParentItemData && currentParentItemData[dataLinkProps.linkCollection] && currentParentItemData[dataLinkProps.linkCollection].includes(_itemKey)) { _selected = true }
      appDataDocumentItem._selected = _selected
    })

    const _selectedAppDataLink = appDataLinks ? _.cloneDeep(appDataLinks[dataLinkProps?.linkCollection]) : {}
    const _selectedItems = {}

    const _linkedData = currentParentItemData[dataLinkProps?.linkCollection]
    if (_linkedData && _.isArray(_linkedData)) {
      _linkedData.forEach(ld => {
        _selectedItems[ld] = {
          _selected: true,
          _changed: false
        }
      })
    }

    convertHelpers.addNameFromKey(_selectedAppDataLink, _appDataDoc)
    convertHelpers.addNameFromKey(_selectedLinkItems, _appDataDoc)

    const xxx = updateLinkHelpers.get_linkedData(_cls, dataLinkProps, appDataLinks);

    setCurrentList(_cls)
    getCurrentLists(_cls)

  }

  const getCurrentLists = (list) => {

    const _currentLists = {
      selected: [],
      available: []
    }

    _.forEach(list, (listItem) => {
      const { _selected } = listItem
      if (_selected) {
        _currentLists.selected.push(listItem)
      } else {
        _currentLists.available.push(listItem)
      }
    })

    _currentLists.selected = _.orderBy(_currentLists.selected, ['_selected', 'lastName', 'name'])
    _currentLists.available = _.orderBy(_currentLists.available, ['_selected', 'lastName', 'name'])

    const _useAlphas = {
      selected: _currentLists.selected.length >= _alphaLimit,
      available: _currentLists.available.length >= _alphaLimit
    }
    setCurrentLists(_currentLists)
    setUseAlphas(_useAlphas)
  }


  /**
   * itemKey is the key of the item selected from the unselected list
   * @param {string} itemKey 
   */
  const handleAmmendSelectedItems = (itemKey) => {

    const _currentList = _.cloneDeep(currentList)

    if (_currentList[itemKey]) {
      // if the itemKey is in the _currentList, toggle selected and mark it as changed
      _currentList[itemKey]._selected = !_currentList[itemKey]._selected
      _currentList[itemKey]._changed = true
    } else {
      // if the itemKey NOT in the _currentList, add a new object with selected and changed
      _currentList[itemKey] = {
        _selected: true,
        _changed: true,
      }
    }

    const _changed = _.filter(_currentList, { _changed: true })

    setCurrentList(_currentList)
    getCurrentLists(_currentList)
    setChanged(_.size(_changed) > 0)
  }

  function generateSheetData(attendees, sessions) {
    const sessionIds = _.keys(sessions, '_itemKey');
    const sessionNames = _.map(sessions, 'name');

    // Header: labels for columns
    const header = ['ID', 'Item Key', 'Name', ...sessionNames];

    // Row 2: session _itemKeys start at the same index as their names in header
    const sessionKeyRow = ['', '', '', ...sessionIds];

    let _index = 0;
    const rows = _.map(attendees, (attendee) => {
      const sessionSet = new Set(attendee.sessions || []);
      const flags = _.map(sessionIds, (_itemKey) => sessionSet.has(_itemKey) ? 'X' : '');
      _index++;
      return [_index, attendee._itemKey, attendee.name, ...flags];
    });

    return [header, sessionKeyRow, ...rows];
  }

  function copyToClipboardForGoogleSheets(data) {
    const tsv = data.map(row => row.join('\t')).join('\n');
    navigator.clipboard.writeText(tsv)
      .then(() => {
        console.log('Copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy:', err);
      });
  }

  const createGsv = () => {
    const collection_row = appDataDocuments[dataLinkProps?.parentCollection]
    const collection_column = appDataDocuments[dataLinkProps?.linkCollection]
    const xxx = generateSheetData(collection_row, collection_column)
    copyToClipboardForGoogleSheets(xxx)
    const sheetName = _.startCase(dataLinkProps?.parentCollection) + '_' + _.startCase(dataLinkProps?.linkCollection)
    getGoggleSheetSimple(googleSheetsId, sheetName)
  }

  const handleView_linkGrid = () => dataLink_handlers.handle_showDataLinker()

  const handleSave_links = async () => {

    setUpdating(true);

    const { _itemKey } = currentParentItemData;
    const xxx = updateLinkHelpers.get_linkedData(currentList, dataLinkProps, appDataLinks);
    const { _newArray, _linkedData, _linkedDataInverse, _linkDataCombined } = xxx

    let addCount = 0;
    let removeCount = 0;

    const batch = writeBatch(mainDb);

    // Create update promises for documents that changed
    // const updatePromises = _.compact(_.map(currentList, (selectedItem, selectedItemKey) => {
    //   const { _changed, _selected } = selectedItem ?? {};

    //   if (_changed) {
    //     const _refPathAlt = createRefPath_event(pathViews, [dataLinkProps.linkCollection, selectedItemKey]);
    //     const updateOperation = _selected ? arrayUnion(_itemKey) : arrayRemove(_itemKey);
    //     const uda = { [key_view]: updateOperation };
    //     _selected ? addCount++ : removeCount++;
    //     return _allowUpdate ? database_fns.doc_update(_refPathAlt, uda, null, batch) : null;
    //   }
    // }));

    _.compact(_.map(currentList, (selectedItem, selectedItemKey) => {
      const { _changed, _selected } = selectedItem ?? {};

      if (_changed) {
        const _refPathAlt = createRefPath_event(pathViews, [dataLinkProps.linkCollection, selectedItemKey]);
        const updateOperation = _selected ? arrayUnion(_itemKey) : arrayRemove(_itemKey);
        const uda = { [key_view]: updateOperation };
        _selected ? addCount++ : removeCount++;
        return _allowUpdate ? database_fns.doc_update(_refPathAlt, uda, null, batch) : null;
      }
    }));

    // Update the actual document
    const _refPath = createRefPath_event(pathViews, [dataLinkProps?.parentCollection, dataLinkProps?.parentCollectionKey]);
    const dataToUpdate = { [dataLinkProps?.linkCollection]: _newArray };

    if (_allowUpdate) {
      database_fns.update_doc(_refPath, dataToUpdate, null, batch)
    }

    // Add linked document updates
    if (appDataLinkType === gEnums.appDataLinkTypes.all || appDataLinkType === gEnums.appDataLinkTypes.documents) {
      const _dataToUpdate1 = _linkedData?.[dataLinkProps?.parentCollection]?.[dataLinkProps?.parentCollectionKey];
      // updatePromises.push(
      updateDocumentHelpers.update_itemInDocuments(
        batch,
        mainDb,
        database_fns,
        pathViews,
        dataLinkProps?.parentCollection,
        dataLinkProps?.parentCollectionKey,
        _dataToUpdate1,
        null,
        _allowUpdate
        // )
      );

      _.forEach(_linkedDataInverse, (linkData, linkDataKey) => {
        _.forEach(linkData, (linkDataItem, linkDataItemKey) => {
          // updatePromises.push(
          updateDocumentHelpers.update_itemInDocuments(
            batch,
            mainDb,
            database_fns,
            pathViews,
            linkDataKey,
            linkDataItemKey,
            linkDataItem,
            null,
            _allowUpdate
          )
          // );
        });
      });
    }

    const _timestamp = Date.now()
    database_fns.update_timestamp(_cacheGroupTypes.eventInfo, pathViews.events, _timestamp, batch)

    const _messages = []

    logBatch(batch, currentList)

    // Wait for all updates to complete before running callback
    try {
      setUpdating(false);
      if (_allowUpdate) {
        await batch.commit();
        _messages.push(`${addCount} items added successfully!`)
        _messages.push(`${removeCount} items removed successfully!`)
        console.log(_messages);
      } else {
        _messages.push(`${addCount} items WOULD HAVE been added successfully!`)
        _messages.push(`${removeCount} items WOULD HAVE been removed successfully!`)
        console.log(_messages);
      }
      setMessages(_messages)
    } catch (error) {
      setUpdating(false);
      _messages.push('Error updating documents')
      console.error('Error updating documents:', error);
      setMessages(_messages)
    }

    setUpdating(false);

  };

  const divs_unique = (svi) => {
    const divs = []
    if (uniqueProps) {
      uniqueProps.forEach(up => {
        switch (up) {
          case 'name':
          case 'lastName':
          case 'firstName':
            break;
          default:
            if (svi[up]) {
              divs.push(<div>{svi[up]}</div>)
            }
        }
      })
    }
    return divs
  }

  const handleAlphaChange = (alphaItem) => {
    const _alphaChar = String.fromCharCode(alphaItem)
    if (alphaRefs && alphaRefs[_alphaChar]) {
      try {
        alphaRefs[_alphaChar].scrollIntoView({ behavior: 'instant', block: 'start' });
      } catch (error) {
        console.log('e', error)
      }
    }
  }

  const alphabetMenu = (dataItems) => {
    const _grouping = {
      alphaDisplayType: gEnums.alphaDisplayTypes.vertical,
      useVerticalHidden: true,
      verticalOpacity: gEnums.opacityTypes.darkest,
      restrictToExisting: true,
      showAlphaCount: true,
      origin: 'dlm',
    }
    return <AlphabetMenuWithProvider
      origin={'dataLinkingMenus'}
      dataItems={dataItems}
      handleAlphaChange={handleAlphaChange}
      grouping={_grouping}
    />
  }

  const menuMenuItems_alt = (list, useAlpha) => {

    const menuItems = []
    const noNames = []

    let currentAlpha;
    let alphaLetter;

    _.forEach(list, (listItem, key) => {

      const { _itemKey, _selected } = listItem

      const mip = {
        name: convertHelpers.getItemName(listItem, true, noNames),
        icon: _selected ? 'check circle outline' : 'circle outline',
        iconColor: _selected ? 'green' : 'grey',
      }

      const alpha = mip.name.charAt(0).toUpperCase();
      const isNewAlpha = alpha !== currentAlpha;
      currentAlpha = alpha

      if (useAlpha && (alphaLetter !== alpha)) {
        menuItems.push(
          <div ref={el => (isNewAlpha ? alphaRefs[alpha] = el : null)} >
            <Menu.Item className='menu-ids-alpha' key={uniqueKey('dls', alpha, key)} >{alpha}</Menu.Item>
          </div>)
        alphaLetter = alpha
      }

      const mi = <Menu.Item key={uniqueKey('dls', key)} >
        <div onClick={() => { handleAmmendSelectedItems(_itemKey) }}>
          <div><Icon name={mip.icon} color={mip.iconColor} ></Icon></div>
          <div className={'menu-item-flex'} >
            <div>{mip.name}</div>
            <div>{_itemKey}</div>
            {divs_unique(listItem)}
          </div>
        </div>
      </Menu.Item>

      menuItems.push(mi)

    })

    return menuItems

  }

  // const header_selected = () => {
  //   const { selected, available } = currentLists ?? {}
  //   const _selectedCount = selected && selected.length
  //   const _availableCount = available && available.length
  //   const _count = _selectedCount + ' of ' + _availableCount
  //   const _caption = showSelected ? 'Selected ' + dataLinkProps?.linkCollection : 'All ' + dataLinkProps?.linkCollection
  //   return <div>
  //     {_.startCase(dataLinkProps?.linkCollection)}
  //     <Label style={{ float: 'right' }} color={showSelected ? 'green' : 'grey'} onClick={() => handleShowSelected()}>
  //       <Icon name={showSelected ? 'check circle' : 'check circle outline'} />{_count}
  //     </Label>
  //     <Label style={{ float: 'right', marginRight: '1em' }} color={soloLinkOnly ? 'blue' : 'grey'} onClick={() => handleSoloLinkOnly()}>
  //       <Icon name={soloLinkOnly ? 'check circle' : 'check circle outline'} />{'Solo Link'}
  //     </Label>
  //   </div>
  // }

  const menuMenuItems = (ss) => {

    const { selected, available } = currentLists ?? {}
    const { selected: selected_alpha, available: available_alpha } = useAlphas ?? {}

    const menuItems = {
      selected: menuMenuItems_alt(selected, selected_alpha),
      available: menuMenuItems_alt(available, available_alpha),
    }

    const cn = 'menu-ids rev'

    let mis;
    let alphaList;
    let useAlpha;

    if (ss) {
      alphaList = selected
      useAlpha = selected_alpha
      mis = <Menu vertical fluid className={cn}>
        {menuItems.selected}
      </Menu>
    } else {
      alphaList = available
      useAlpha = available_alpha
      mis = <Menu vertical fluid className={cn}>
        {menuItems.available}
      </Menu>
    }

    const _content = useAlpha ? <div>
      {useAlpha && alphabetMenu(alphaList)}
      <div ref={topRef}></div>
      {mis}
    </div> : mis

    return <Wrapper
      content={_content}
    />
  }

  const header_menu = (caption, list, color, icon) => {
    const _count = _.size(list)
    return <div>
      {_.startCase(caption)}
      <Label color={color} size={_labelSize} style={{ float: 'right' }}  >
        <Icon name={icon} />{_count}
      </Label>
    </div>
  }

  const wrapper_menu = (ss) => <Wrapper
    header={ss ? header_menu('Selected', currentLists?.selected, 'green', 'check circle') : header_menu('available', currentLists?.available, 'black', 'circle outline')}
    content={menuMenuItems(ss)}
    wrapperType={wrapperTypes.paddedHeader}
  />

  const modal = () => {
    const _mess = []
    _.forEach(messages, m => {
      _mess.push(<div>{m}</div>)
    })
    return <Message icon size='small' color='black'>
      <Icon name='check circle' color='green' />
      <Message.Content>
        <Message.Header>Success</Message.Header>
        <div style={{ padding: '1em 0' }}>  {_mess}</div>
      </Message.Content>
    </Message>
  }

  const wvc_linking = () => <WrapperVertCols mvc={'2'}>
    {wrapper_menu(false)}
    {wrapper_menu(true)}
  </WrapperVertCols>

  const buttons = () => {
    const btns = []
    btns.push({ oc: handleSave_links, caption: 'Update Links', icon: 'save', disabled: !changed, color: _allowUpdate ? 'green' : 'olive' })
    btns.push({ oc: resetList, caption: 'Reset', icon: 'redo', disabled: !changed, fl: true })
    btns.push({ oc: createGsv, caption: 'Create GSV', icon: 'arrow right', fl: true })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_appDataDoc = () => <Wrapper
    content={currentList ? messages ? modal() : wvc_linking() : <div style={{ padding: '1em' }}>No Related Item Selected</div>}
    footer={buttons()}
    noMid={false}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    updating={updating}
  />

  return wrapper_appDataDoc()

}

export default DataLinkingMenus